import { apiRequest } from '@/utils/api-request';
import type { FilestoreTreeResponse } from '@/types/filestore';
import { filestoreErrorMessage } from './filestore-request';

export async function getFilestoreTree(
  orgId: string,
  repo: string,
  dirPath = '',
  ref?: string,
): Promise<FilestoreTreeResponse> {
  const query = new URLSearchParams();
  if (dirPath) query.set('path', dirPath);
  if (ref) query.set('ref', ref);
  const qs = query.toString();

  const response = await apiRequest<FilestoreTreeResponse>({
    url: `/v1/orgs/${orgId}/repos/${encodeURIComponent(repo)}/tree${qs ? `?${qs}` : ''}`,
    method: 'GET',
    target: 'filestore',
  });

  if (response.detail || !response.data) {
    throw new Error(filestoreErrorMessage(response, 'Failed to load folder'));
  }
  return response.data;
}
